import React from "react";
import fileDialog from "file-dialog";
import {htmlToText} from "html-to-text";
import {sendMessage, sendSlackMessage, supPayout} from "./common";
import {PDFDocument} from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import {StorageRounded} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Link} from "@mui/material";
import Paper from "@mui/material/Paper";
import ButtonBase from "@mui/material/ButtonBase";
import {apiFetch, baseUrl} from '../api/restClient';
import {OverlayTooltip} from "../components/common/OverlayTooltip";
import {editorConfig} from "../constants/common";

const slackHost = 'https://tool.click.fan';

const getInvoiceEditUrl = (type, invoiceOrId) => {
    const id =
        typeof invoiceOrId === 'string'
            ? invoiceOrId
            : invoiceOrId?.uuid || invoiceOrId?._id || invoiceOrId?.id || invoiceOrId?.oid;
    const tab = type || 'operations';
    if (!id) return `${slackHost}/invoices/${tab}`;
    return `${slackHost}/invoices/${tab}?edit=${id}`;
};
const financeSlackHook = 'https://hooks.slack.com/services/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';//Natascha
// const financeSlackHook = 'https://hooks.slack.com/services/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' //Christian

export const sendDemandInvoiceChangedNotification =
    (token, invoiceObject, invoiceObjectId, whatWasChanged, changedValue, address) => {

        const form = {
            "text": `:heavy_dollar_sign: *Invoice changed*`,
            "attachments": [
                {
                    "text": whatWasChanged ?
                        `Invoice:\t${invoiceObject.invoiceText}\nType:\t\t${whatWasChanged}\nValue:\t${changedValue}`
                        :
                        `Invoice:\t${invoiceObject.invoiceText}`,
                    "color": "#3AA3E3",
                    "attachment_type": "default",
                    "actions": [
                        {
                            "name": "card",
                            "text": "Show Invoice",
                            "type": "button",
                            "url": getInvoiceEditUrl('demand', invoiceObjectId)
                        }
                    ]
                }
            ]
        };
        sendSlackMessage(form, address, token)
            .then(res => res)
            .catch(err => console.log(err))

    }

export const notifyFinanceNewDemandInvoice = (token, invoiceText, invoiceObjectId) => {
    const address = financeSlackHook;
    const form = {
        "text": `:new: *New demand invoice request created*`,
        "attachments": [
            {
                "text": `New invoice: ${invoiceText}`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl('demand', invoiceObjectId)
                    }
                ]
            }
        ]
    };
    sendSlackMessage(form, address, token)
        .then(res => res)
        .catch(err => console.log(err))
};

export const notifyFinanceReleaseInvoice = (token, invoice, type = 'supply') => {
    const address = financeSlackHook;
    const form = {
        "text": `*Pease pay invoice*`,
        "attachments": [
            {
                "text": `Please Pay:\tChannel: ${invoice.channelName}\tCampaign: ${invoice.campaignName}`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoice)
                    }
                ]
            }
        ]
    };
    sendSlackMessage(form, address, token)
        .then(res => res)
        .catch(err => console.log(err))
};

export const notifyAMAboutSupplyInvoice = (token, address, state, invoice, type = 'supply') => {
    const form = {
        "text": `${state ? ':heavy_check_mark:' : ':no_entry_sign:'} *Invoice ${state ? 'approved' : 'rejected'}*`,
        "attachments": [
            {
                "text": `Invoice: ${state ? 'approved' : 'rejected'}\tChannel: ${invoice.channelName}\tCampaign: ${invoice.campaignName}`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoice)
                    }
                ]
            }
        ]
    };
    sendSlackMessage(form, address, token)
        .then(res => res)
        .catch(err => console.log(err))
};

export const notifyAboutOperationsInvoiceApprovalRequest = (token, address, invoice, type = 'operations') => {

    // return;

    const form = {
        "text": `:heavy_check_mark: *Invoice approval request*`,
        "attachments": [
            {
                "text": `Invoice needs your approval`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoice)
                    }
                ]
            }
        ]
    };
    sendSlackMessage(form, address, token)
        .then(res => res)
        .catch(err => console.log(err))
};

export const notifyAboutOperationsInvoicePaymentRequest = (token, address, invoice, type = 'operations') => {

    // return;

    const form = {
        "text": `:moneybag: *Invoice payment request*`,
        "attachments": [
            {
                "text": `Invoice needs your payment action`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoice)
                    }
                ]
            }
        ]
    };
    sendSlackMessage(form, address, token)
        .then(res => res)
        .catch(err => console.log(err))
};

export const notifySupplyInvoicePaid = (token, address, invoice, type = 'supply') => {

    const form = {
        "text": `:heavy_dollar_sign: *Invoice paid*`,
        "attachments": [
            {
                "text": `Invoice: paid\tChannel: ${invoice.channelName}\tCampaign: ${invoice.campaignName}`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoice)
                    }
                ]
            }
        ]
    };
    sendSlackMessage(form, address, token)
        .then(res => res)
        .catch(err => console.log(err))
};

export const notifyFinanceNewSupplyInvoice = (token, invoiceText, invoiceObjectId, type = 'supply') => {
    // console.log('sendMessage to FINANCE');
    // return;

    const address = financeSlackHook;
    const form = {
        "text": `:new: *New supply invoice upload*`,
        "attachments": [
            {
                "text": `New invoice: ${invoiceText}`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoiceObjectId)
                    }
                ]
            }
        ]
    };
    return sendSlackMessage(form, address, token);
};

export const notifyFinanceNewOperationsInvoice = (token, invoiceText, invoiceObjectId, type = 'operations') => {

    // return;

    const address = financeSlackHook;
    const form = {
        "text": `:new: *New operations invoice upload*`,
        "attachments": [
            {
                "text": `New invoice: ${invoiceText}`,
                "color": "#3AA3E3",
                "attachment_type": "default",
                "actions": [
                    {
                        "name": "card",
                        "text": "Show Invoice",
                        "type": "button",
                        "url": getInvoiceEditUrl(type, invoiceObjectId)
                    }
                ]
            }
        ]
    };
    return sendSlackMessage(form, address, token);
};

export const analyzeInvoiceWithAI = async (pdfFile, apiToken) => {
    if (!pdfFile || !apiToken) return null;

    try {
        const arrayBuffer = await pdfFile.arrayBuffer();
        const bytes = new Uint8Array(arrayBuffer);
        let binary = '';
        for (let i = 0; i < bytes.length; i += 1) {
            binary += String.fromCharCode(bytes[i]);
        }
        const pdfBuffer = btoa(binary);
        return await apiFetch('/invoice/analyzeInvoiceOpenAI', {
            method: 'POST',
            token: apiToken,
            body: {pdfBuffer},
        });
    } catch (err) {
        console.log('analyzeInvoiceWithAI failed, continuing with Textract only', err);
        return null;
    }
};

export const storeFile = (files, type, apiToken, profile) => new Promise((resolve, reject) => {

    const formData = new FormData();
    formData.append('file', files[0]);

    // const storageUrl = `http://localhost:8080/storage/${type === 'demand' ? 'uploadDemInv' : type === 'operations' ? 'uploadOperationsInv' : 'uploadSupInv'}`;
    const storageUrl = `${baseUrl}/storage/${type === 'demand' ? 'uploadDemInv' : type === 'operations' ? 'uploadOperationsInv' : 'uploadSupInv'}`;
    return fetch(storageUrl, {
        method: 'post',
        body: formData,
        headers: {
            'Authorization': `Bearer ${apiToken}`
        }
    })
        .then(res => {
            if (!res) {
                return Promise.reject('Unable to save the invoice. Please check the connection');
            }
            return res.json().catch(err => console.log(err));
        })
        .then(({doc, file: {location, originalname}}) => {

            const {ExpenseDocuments} = doc || [];
            const analyzeResultObject = ExpenseDocuments?.[0]?.SummaryFields?.reduce((a, c) => {
                return {
                    ...a,
                    [c.Type?.Text]: c.ValueDetection?.Text,
                }
            }, {})

            const analyzeResultTextObject = ExpenseDocuments?.[0]?.LineItemGroups?.[0]?.LineItems?.[0]?.LineItemExpenseFields?.reduce((a, c) => {
                return {
                    ...a,
                    [c.Type?.Text]: c.ValueDetection?.Text,
                }
            }, {})


            resolve({
                type: 'fileupload',
                name: originalname,
                link: location,
                when: new Date(),
                who: profile.nickname,
                analyzeResultObject,
                analyzeResultTextObject,
            })
        })
        .catch(err => {
            console.log(err);
            reject(err);
        })
});

export const fileUpload = (authUser, firebase, type) =>
    fileDialog({multiple: false}).then(files => storeFile(files, authUser, firebase, type));

export const getLatestInvoice = (invoiceArray) => invoiceArray.reduce((a1, a2) => a1.when > a2.when ? a1 : a2);

export const getLatestReminder = invoice => {
    return invoice.reminder ? invoice.reminder?.reduce((a, c) => {
        if (!a.dateSent || a.dateSent < c.dateSent)
            return c
        return a;
    }, {state: 0}) : {state: 0}

}

// todo test with all invoice type !!
export const saveInvoice = (invoiceDetails, {apiToken, profile, type, value, userAssets, roles} = {}) =>
    new Promise((resolve, reject) => {

        const invoiceObject = {...invoiceDetails}

        if (invoiceDetails.comment)
            invoiceObject.comments = [{
                who: profile.nickname,
                when: new Date(),
                what: invoiceDetails.comment,
            }];
        if (typeof invoiceDetails.reminder === 'number') {
            invoiceObject.reminder = [{state: invoiceDetails.reminder, dateSent: new Date()}];
        } else if (invoiceDetails.reminder && !Array.isArray(invoiceDetails.reminder)) {
            invoiceObject.reminder = [invoiceDetails.reminder];
        }

        const url = `/invoice/`;
        const predefinedUuid = invoiceObject.predefinedUuid;
        delete invoiceObject.predefinedUuid;

        const method = (!invoiceObject.uuid || predefinedUuid) ? 'post' : 'put';
        if (predefinedUuid) {
            invoiceObject.uuid = predefinedUuid;
        }

        apiFetch(
            url,
            {
                method,
                body: invoiceObject,
                token: apiToken,
            }
        )
            .then(res => {
                if (!res) {
                    return Promise.reject('Unable to save the invoice. Please check the connection');
                }
                return res;
            })
            .then(res => {
                // Only demand invoices use the "invoice changed" Slack notification flow.
                // Supply and operations follow their own notification paths.
                if (invoiceDetails.type !== 'demand' || invoiceDetails.comment)
                    return res;

                if (value && (value === 'prepare' || value === 'canceled') && !roles.includes('FINANCE')) {
                    sendDemandInvoiceChangedNotification(
                        apiToken,
                        invoiceObject,
                        {uuid: res[0]?.uuid, _id: res[0]?._id},
                        type,
                        value,
                        financeSlackHook
                    );
                    return res;
                }

                if (userAssets && userAssets[invoiceObject.accountManager] && roles.includes('FINANCE')) // Finance changed something, notify AM
                {
                    sendDemandInvoiceChangedNotification(
                        apiToken,
                        invoiceObject,
                        {uuid: res[0]?.uuid, _id: res[0]?._id},
                        type,
                        value,
                        userAssets[invoiceObject.accountManager].slackHook
                    );
                }
                return res;
            })
            .then(resolve)
            .catch(err => {
                console.log(err);
                reject(err);
            })

    });

export const getCard = (campaignMetaId, authUser, firebase, apitoken) => new Promise((resolve, reject) => {

    if (!campaignMetaId)
        return;

    const url = `/campaignMeta/campaignMeta/${campaignMetaId}`;

    apiFetch(
        url,
        {
            method: 'get',
            token: apiToken,
        }
    )
        .then(res => {
            if (!res) {
                return Promise.reject('Unable to get the card. Please check');
            }
            return res;
        })
        .then(resolve)
        .catch(err => {
            console.log(err);
            reject(err);
        })

});

export const getInvoice = (invoiceObjectId, {authUser, firebase, apiToken}) => new Promise((resolve, reject) => {

    if (!invoiceObjectId)
        return;

    const url = `/invoice/${invoiceObjectId}`;

    apiFetch(
        url,
        {
            method: 'get',
            toke: apiToken,
        }
    )
        .then(res => {
            if (!res) {
                return Promise.reject('Unable to get the invoice. Please check the connection');
            }
            return res;
        })
        .then(resolve)
        .catch(err => {
            console.log(err);
            reject(err);
        })

});

export const getOperationsInvoice = (invoiceObjectId, {
    authUser,
    firebase,
    apiToken
}) => new Promise((resolve, reject) => {

    if (!invoiceObjectId)
        return resolve(null);

    const url = `/invoice/operations/${invoiceObjectId}`;

    apiFetch(
        url,
        {
            method: 'get',
            toke: apiToken,
        }
    )
        .then(res => {
            if (!res) {
                return Promise.reject('Unable to get the invoice. Please check the connection');
            }
            return res;
        })
        .then(resolve)
        .catch(err => {
            console.log(err);
            reject(err);
        })

});

/**
 * Add a new Invoice to a campaign meta card
 * @param invoice
 * @param profile
 * @param notify
 */
export const campaignMetaAddInvoice = (invoice, {profile, notify, apiToken}) => {

    const query = `/campaignMeta/`;
    const entry = {
        campaignMetaId: invoice.campaignMetaId,
        history: {
            who: profile.nickname,
            when: new Date(),
            what: 'added invoice',
        },
        newInvoice: invoice,
    }

    return apiFetch(query, {
        method: 'put',
        body: {entry},
        token: apiToken,
    })
        .then(response => {
            if (response.status !== 200) {
                notify({message: `Something went wrong: API seems bitching`, severity: 'error'});
            }
            return response;
        })
        .then(response => {
            notify({message: 'Card updated', severity: 'success'});
            return response
        })
        .catch(err => {
            console.log(err);
            notify({message: `Something went terribly wrong: ${err}`, severity: 'error'});
        })

};

export const missingSignedContractFileMessage = (creative, userAssets, apiToken) => {
    const campaignId =
        creative?.campaign?.campaignId ||
        creative?.campaign?._id ||
        creative?.campaign?.id ||
        (typeof creative?.campaign === 'string' ? creative.campaign : null) ||
        creative?.campaignId ||
        creative?.campaignMeta?.campaignId ||
        creative?.campaignMeta?._id ||
        creative?.campaignMeta?.id ||
        creative?.campaignMetaId;

    return sendMessage({
            channelName: creative.channel.name,
            campaignName: creative.campaign.name,
            campaignId,
            creativeId: creative.uuid || creative._id || creative.id,
        },
        apiToken, 'missingSignedContractFile',
        userAssets['Christian']?.slackHook
    )
}

export const checkForNewMentions = (
    type = 'supply',
    comment,
    userAssets,
    invoiceId,
    apiToken,
    invoiceName,
    version = 1,
    invoiceUuid,
    metadata = {}
) => new Promise((resolve, reject) => {

    const members = editorConfig.mention.feeds[0].feed;
    const sendArray =
        version === 1 ? members.reduce((acc, member) => {
            if (comment.includes(member)) {
                acc = acc.concat([member.replace('@', '')])
            }
            return acc
        }, []) : [...comment.matchAll(/@\[[^\]]+\]\(([^)]+)\)/g)].map(m => m[1])


    if (sendArray.length > 0) {
        for (const assignee of sendArray) {
            const slackHook = userAssets?.[assignee]?.slackHook;
            if (slackHook)
                sendMessage({
                        invoiceId,
                        invoiceUuid: invoiceUuid || invoiceId,
                        invoiceName,
                        ...metadata,
                        comment: htmlToText(comment.replace(/@\[[^\]]+\]\(([^)]+)\)/g, "*$1*"), {
                            wordwrap: 130
                        }),
                    },
                    apiToken,
                    type === 'supply' ? 'newSupplyInvoiceComment' :
                        type === 'demand' ? 'newDemandInvoiceComment' :
                            type === 'vacations' ? 'newVacationsComment' :
                                type === 'creative' ? 'newCreativeComment' :
                                    'newOperationsInvoiceComment',
                    slackHook
                )
                    .then(resolve)
                    .catch(err => {
                        reject(err)
                    })
        }
    }
});

export const dzBaseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: '16px',
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

export const dzActiveStyle = {
    borderColor: '#41133f'
};

export function InvoiceAttachmentsView({
                                           invoiceDetails,
                                           previewAttachment,
                                           getRootProps,
                                           getInputProps,
                                           style,
                                           dropZoneText,
                                           isFinance = false
                                       }) {
    const metadataEnabled = (invoiceDetails?.type === 'supply' && isFinance);

    if (invoiceDetails.attachments?.length > 0) {
        const lastInvoice = getLatestInvoice(invoiceDetails.attachments);

        const handleDownloadOptions = async (e) => {
            e.preventDefault();
            if (metadataEnabled) {
                await handleDownloadWithMetadata();
            } else {
                await downloadUrl(lastInvoice.link, lastInvoice.name || "invoice.pdf");
            }
        };

        const handleDownloadWithMetadata = async () => {
            try {
                const meta = {
                    'Account Manager': invoiceDetails.accountManager ?? '',
                    'Campaign Name': invoiceDetails.campaignName ?? '',
                    'Channel Name': invoiceDetails.channelName ?? '',
                    'UUID': invoiceDetails.uuid ?? '',
                    'Platform': invoiceDetails.creative.type ?? '',
                    'Cost Type': invoiceDetails.creative.costType ?? '',
                    'Format': invoiceDetails.creative.format ?? '',
                    'Release Date': formatDate(invoiceDetails.creative.startDate, false) ?? '',
                };

                await appendMetadataAndDownload(lastInvoice.link, lastInvoice.name || "invoice.pdf", meta);
            } catch (err) {
                console.error("Failed to fetch metadata or build PDF:", err);
            }
        };

        return (
            <>
                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'stretch' }}>
                    <OverlayTooltip
                        arrow
                        placement={"left-start"}
                        title={
                            <>
                                <Typography variant={"h6"}>Document download</Typography>
                                <br/>
                                <Typography variant={"body2"}>
                                    Hint: click the icon to preview
                                </Typography>
                            </>
                        }
                        containerSx={{ display: "flex", width: "100%", height: "100%" }}
                    >
                        <Link
                            href={lastInvoice?.link}
                            onClick={handleDownloadOptions}
                            color="inherit"
                            style={{display: "flex", width: "100%", height: "100%"}}
                        >
                            <Paper style={{ margin: 0, width: "100%", minHeight: 106, display: "flex", alignItems: "center" }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', px: 1.5, py: 1 }}>
                                    <ButtonBase
                                        style={{ width: 72, height: 72, flexShrink: 0 }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            previewAttachment(e, lastInvoice?.link)
                                        }}
                                    >
                                        <StorageRounded sx={{ fontSize: 32 }} />
                                    </ButtonBase>
                                    <Box sx={{ minWidth: 0, pl: 1.5 }}>
                                        <Typography variant="subtitle1" style={{ fontSize: "0.8rem", fontWeight: 600 }}>
                                            Invoice
                                        </Typography>
                                        <Typography variant="subtitle2" style={{ fontSize: "0.8rem", fontWeight: 600, overflowWrap: "anywhere" }}>
                                            {lastInvoice?.name}
                                        </Typography>
                                        <Typography variant="body2" style={{ fontSize: "0.7rem" }}>
                                            {`Added: ${formatDate(lastInvoice?.when, true)} by ${lastInvoice?.who}`}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Paper>
                        </Link>
                    </OverlayTooltip>
                </Grid>

                {/* keep your right-side dropzone */}
                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'stretch' }}>
                    <section className="container" style={{ width: '100%', height: '100%' }}>
                        <div {...getRootProps({ style: { ...style, minHeight: 106, height: '100%', boxSizing: 'border-box', justifyContent: 'center' } })}>
                            <input {...getInputProps()} />
                            Drop invoice or click to update
                        </div>
                    </section>
                </Grid>
            </>
        );
    }

    return (
        <Grid item xs={12}>
            <section className="container">
                <div {...getRootProps({style})}>
                    <input {...getInputProps()} />
                    {dropZoneText}
                </div>
            </section>
        </Grid>
    );
};

/*
* function calculates whether the configured invoice amount differs from the offer
* - prePayment ?
* - otherChannels in invoice?
* */
export const isOfferDifferentFromInvoice = (
    isPrePayment, amount, currency, otherChannelsSupplyInfo, creative, otherInvoices, exchangeRate) => {

    if (!amount || isPrePayment) // maybe a new invoice, we don't need to warn
        return {differ: false};

    if (creative.creativeId === 'XXHy3qdMEuE' || creative.creativeId === 'elleswift240115')
        return {differ: false}

    // if the creative is for some reason also in the otherChannelsSupplyInfo array!
    // i can't find the right place to fix it there
    // ToDo refactor !!
    const creativeIsInOCSI = otherChannelsSupplyInfo?.find(item => {
        return (item.creative.uuid === creative.uuid)
        // return (item.creative.channel.name === creative.channel.name && item.model === creative.supply.model)
    });
    //
    // we have already some other invoice ?
    const otherInvoicesAmount = otherInvoices?.reduce((accu, current) => accu + current.amount, 0) || 0;
    // compareAmount is currency independent, check comes below
    const compareAmount = parseInt(amount) + otherInvoicesAmount;

    // when there are other channels connected, we need to sum all payouts
    // and compare witht the invoice
    const supplyPayouts = otherChannelsSupplyInfo ?
        otherChannelsSupplyInfo
            .reduce((accu, current) => accu +
                    supPayout(current.creative),

                creativeIsInOCSI ? 0 : supPayout(creative)) // initial value is selected invoice amount
        :
        supPayout(creative) //todo the otherCurrency case !!!

    // the other currencies case
    if (currency !== 'USD') { // we can do this, because USD is our system currency
        //now two cases
        // 1. creative.supply.payoutOther exists
        const supplyPayoutsOther = otherChannelsSupplyInfo ?
            otherChannelsSupplyInfo
                .reduce((accu, current) => accu + current.payoutOther,
                    creativeIsInOCSI ? 0 : creative.supply?.payoutOther) // initial value is selected invoice amount
            : creative.supply?.payoutOther //todo the otherCurrency case !!!

        if (creative.supply?.payoutOther) {
            return {
                differ: compareAmount !== supplyPayoutsOther,
                amount: supplyPayoutsOther
            }
        }
        // 2. creative.supply.payoutOther does not exist
        if (!creative.supply?.payoutOther) {
            const value = supplyPayouts / exchangeRate; // we calculate with the day rate
            return {
                differ: compareAmount > value,
                amount: supplyPayouts
            }
        }
    }

    return {
        differ: compareAmount !== Math.ceil(supplyPayouts),
        amount: supplyPayouts || 0,
    }
};

const HISTORICAL_CREATIVE_STATES = new Set(['deleted', 'dropped']);

const getHistoricalCreativeState = (invoice) => {
    const states = [
        invoice?.creative?.state,
        ...(Array.isArray(invoice?.otherChannelsSupplyInfo)
            ? invoice.otherChannelsSupplyInfo.flatMap((item) => [item?.state, item?.creative?.state])
            : []),
    ];

    return states.find((state) => HISTORICAL_CREATIVE_STATES.has(String(state || '').toLowerCase())) || null;
};

const addHistoricalCreativeWarning = (result, invoice) => {
    const historicalState = getHistoricalCreativeState(invoice);
    if (!historicalState) return result;

    const warningText = `Review amount: this invoice includes a ${historicalState} creative. Historical creatives are included in the calculation, but the amount requires manual confirmation.`;

    return {
        ...result,
        warning: true,
        failText: result.differ ? `${result.failText} ${warningText}` : warningText,
    };
};

export const isOfferDifferentFromInvoice2 = ({isPrePayment, invoice}) => {

    if (!invoice.amount || isPrePayment) // maybe a new invoice, we don't need to warn
        return {differ: false};

    const isMultiChannelInvoice = !!(
        Array.isArray(invoice.otherChannels) &&
        invoice.otherChannels.length > 0 &&
        invoice.otherChannels?.[0]?.channelId
    );
    const sPay = supPayout(invoice.creative);

    const numericAmount = (value) => {
        if (value === null || value === undefined || value === '') return 0;
        if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
        const normalized = String(value).replace(/,/g, '').replace(/[^0-9.-]/g, '');
        const parsed = parseFloat(normalized);
        return Number.isFinite(parsed) ? parsed : 0;
    };
    const roundedExpectedAmount = (value) => Number(Number(value || 0).toFixed(0));
    const totalIncludingOtherInvoicesForCreative =
        numericAmount(invoice.amount) + numericAmount(invoice.bulkRest);
    const actualAmount = roundedExpectedAmount(totalIncludingOtherInvoicesForCreative);

    let result;

    if (isMultiChannelInvoice) {

        if (invoice.currency !== 'USD') {
            const multiPay =
                (sPay / invoice.creative.supply.exchangeRate) + invoice.otherChannelsSupplyInfo?.reduce((a, c) => a + c.maxPayoutOther, 0);
            const expectedAmount = roundedExpectedAmount(multiPay);

            result = {
                differ: actualAmount !== expectedAmount,
                amount: multiPay,
                failText: `Amount should be ${expectedAmount} EURO (${invoice.name}: ${
                    roundedExpectedAmount(sPay / invoice.creative.supply.exchangeRate)} ${
                    invoice.otherChannelsSupplyInfo?.map(item => `${item.name}: ${item.maxPayoutOther} `)
                })`
            }
        } else {
            const multiPay = sPay + invoice.otherChannelsSupplyInfo?.reduce((a, c) => a + supPayout(c.creative), 0);
            const expectedAmount = roundedExpectedAmount(multiPay);
            result = {
                differ: actualAmount !== expectedAmount,
                amount: multiPay,
                failText: `Amount should be USD ${expectedAmount} (${invoice.name}: ${
                    roundedExpectedAmount(sPay)} ${
                    invoice.otherChannelsSupplyInfo?.map(item => {
                        return `${item.name}: ${supPayout(item.creative)} `
                    })
                })`
            }
        }

    } else { // singleChannelInvoice - works correct for fix, fixplus, cpm

        if (invoice.currency !== 'USD') {

            const expectedAmount = roundedExpectedAmount(sPay / invoice.creative.supply.exchangeRate);

            result = {
                differ: actualAmount !== expectedAmount,
                amount: sPay / invoice.creative.supply.exchangeRate,
                failText: `Amount should be ${expectedAmount} EUR`,
            }
        } else {
            const expectedAmount = roundedExpectedAmount(sPay);

            result = {
                // todo change to a proper solution. So far the multiInvoiceInvoice works only from the reporting startpoint!!!!
                differ: actualAmount !== expectedAmount,
                amount: sPay,
                failText: `Amount should be USD ${expectedAmount}`,
            }
        }
    }

    return addHistoricalCreativeWarning(result, invoice);
};

// helper functions for Invoice PDF download
async function downloadUrl(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "";
    document.body.appendChild(a);
    a.click();
    a.remove();
}

async function appendMetadataAndDownload(pdfUrl, filename, metadataObj) {
    // 1) Load original PDF
    const originalBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
    const pdfDoc = await PDFDocument.load(originalBytes);

    // 2) Drop Channel Name if it is NOT alphanumeric
    if (metadataObj && Object.prototype.hasOwnProperty.call(metadataObj, 'Channel Name')) {
        const ch = metadataObj['Channel Name'];
        if (hasNonLatinOrNumber(ch)) {
            delete metadataObj['Channel Name'];
        }
    }

    // 3) Use a standard font
    pdfDoc.registerFontkit(fontkit);

    const fontBytes = await fetch("/fonts/NotoSans-Regular.ttf").then(r => r.arrayBuffer());
    const font = await pdfDoc.embedFont(fontBytes);

    // 4) Create the metadata page
    let page = pdfDoc.addPage();
    const {width, height} = page.getSize();
    const fontSize = 12;

    let y = height - 50;
    page.drawText("Invoice Metadata", {x: 50, y, size: 18, font});
    y -= 30;

    const lines = Object.entries(metadataObj || {}).map(([k, v]) => `${k}: ${String(v)}`);
    for (const line of lines) {
        page.drawText(line, {x: 50, y, size: fontSize, font});
        y -= 18;
        if (y < 50) {
            y = height - 50;
            page = pdfDoc.addPage();
        }
    }

    // 5) Save/Download
    const mergedBytes = await pdfDoc.save();
    const blobUrl = URL.createObjectURL(new Blob([mergedBytes], {type: "application/pdf"}));
    await downloadUrl(blobUrl, filename?.replace(/\.pdf$/i, "") + "_with_metadata.pdf");
    URL.revokeObjectURL(blobUrl);
};

const hasNonLatinOrNumber = (s) => {
    const str = String(s ?? '');
    if (!str) return false;
    return !/^[\p{Script=Latin}\p{Number}\s\-_.,&()/]+$/u.test(str);
};

export const addSubChannel = (data, method = 'PUT', apiToken) => new Promise((resolve, reject) => {

    const reqOptions = {
        method,
        token: apiToken,
        body: data,
    };

    apiFetch(`/channel/addSubChannel`, reqOptions)
        .then(resolve)
        .catch(reject);
});

export const removeSubChannel = (data, method = 'PUT', apiToken) => new Promise((resolve, reject) => {

    const reqOptions = {
        method,
        token: apiToken,
        body: data,
    };

    apiFetch(`/channel/ext/removeSubChannel`, reqOptions)
        .then(resolve)
        .catch(reject);
});

export const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined || Number.isNaN(value)) return '';
    return Number(value).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};

export const formatDate = (value, monthOnly = false) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return monthOnly ? d.toLocaleDateString('en-US', {month: 'short'})
        : d.toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        });
};
